export enum ISuggestionType {
  SUGGESTION = 'SUGGESTION',
  COMPLAINT = 'COMPLAINT',
  OBJECT_LOST = 'OBJECT_LOST'
}

export enum ISuggestionComplaint {
  SERVICE_IMPROVEMENT = 'SERVICE_IMPROVEMENT',
  TIMETABLES = 'TIMETABLES',
  VEHICLE_CONDITIONS = 'VEHICLE_CONDITIONS',
  DRIVER = 'DRIVER',
  PUNCTUALITY = 'PUNCTUALITY',
  APP = 'APP',
  SIGN_UP_AND_LOG_IN = 'SIGN_UP_AND_LOG_IN',
  BOOKING_PROCESS = 'BOOKING_PROCESS',
  BOOKINGS_AND_CANCELLATIONS = 'BOOKINGS_AND_CANCELLATIONS',
  PENALTIES = 'PENALTIES',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  BACKOFFICE = 'BACKOFFICE',
  OTHERS_ABOUT_APP = 'OTHERS_ABOUT_APP',
  OBJECT_LOST = 'OBJECT_LOST',
  OTHERS = 'OTHERS'
}
